import React, { useState } from 'react'
import flex from '../../styles/flex';
import { IconButton } from '@mui/material';
import { FiAtSign, FiEdit, FiTrash } from 'react-icons/fi';
import { EventCategory, IGetWebHookEndPointById, WebHook } from '../../logic/api';
import ConfirmationDialog from '../notifications/confirmationDialog/ConfirmationDialog';
import { useTranslation } from 'react-i18next';
import { ReleaseFlag, useReleaseManagement } from '@/utility/feature-management';

interface IWebhookListItemProps {
    item: WebHook;
    onEdit: (item: IGetWebHookEndPointById) => void;
    onDelete: () => void;
}


const WebhooksListItem = (props: IWebhookListItemProps) => {

    const [showDeleteConfirmation, setShowDeleteConfirmation] = useState(false);
    const handleDeleteConfirmation = (result: boolean) => {
        setShowDeleteConfirmation(false);
        if (result) {
            props.onDelete();
        }
    }

    const { t } = useTranslation();

    const isAssetTrackingWebHookReleased = useReleaseManagement(ReleaseFlag.releaseAssetTrackingWebhook);
    const isLocationsWebhookReleased = useReleaseManagement(ReleaseFlag.releaseLocationWebhooks);

    return (
        <div style={{ border: "solid 1px lightgray", padding: 10, borderRadius: 5, marginBottom: 5 }}>
            <div style={{ ...flex.flexRows, justifyContent: "space-between", alignItems: "center" }}>
                <div style={{ ...flex.flexMain, textAlign: "left" }}>
                    <div style={{ display: 'flex', alignItems: 'center' }}>
                        <IconButton disabled={true}>
                            <FiAtSign />
                        </IconButton>
                        <strong>{props.item?.endpoint}</strong>
                    </div>
                </div>
                <div style={{ ...flex.flexAuto, display: 'flex', flexDirection: 'column', alignItems: 'center' }}>
                    <p>{t("webhooks.eventCat")}</p>
                    <strong style={{ textTransform: 'capitalize', marginBottom: 10 }}>{props.item?.categories.map(category => {
                        if (
                            !isAssetTrackingWebHookReleased && category === EventCategory.assetTracking
                            || !isLocationsWebhookReleased && category === EventCategory.location) {
                            return `${EventCategory[category]} [disabled]`
                        }

                        return EventCategory[category]
                    }).join(', ')}</strong>
                </div>

                <div style={{ ...flex.flexAuto, textAlign: "right" }}>
                    <IconButton onClick={() => { props.onEdit(props.item) }}>
                        <FiEdit />
                    </IconButton>
                    <IconButton
                        style={{ color: 'red' }}
                        onClick={() => { setShowDeleteConfirmation(true) }}
                    >
                        <FiTrash />
                    </IconButton>
                </div>
            </div>
            <ConfirmationDialog title={t("webhooks.deleteEndpoint")} message={t("users.deleteEndpointConfirm")} show={showDeleteConfirmation} onClose={handleDeleteConfirmation} />
        </div>
    );
}
export default WebhooksListItem